import { GraphNavAdapter } from "../../../../../graphics/graph-nav-adapter";

export class chooseCmpxGraphNavAdapter extends GraphNavAdapter {
    areaRect;
    hoverRect;
    selectRect;

    setupRectangles = async () => {
        const contentGroups = this.chartProvider.charts;

        contentGroups.forEach((item, index) => {
            const rectContentGroup = item.findContentGroup("rectangle");
            if (rectContentGroup !== undefined) {
                const rectGroup = rectContentGroup;
                const hovered = rectGroup.findByName("hovered");
                const select = rectGroup.findByName("select");
                const area = rectGroup.findByName("area");

                this.hoverRect = hovered;
                this.areaRect = area;
                this.selectRect = select;
            }
        });
    };

    moveHoverRectangle = async (x, width) => {
        if (!isNaN(x) && !isNaN(width)) {
            await Promise.all([
                this.hoverRect.move(this.valueConverter.convertPointsToPixels(x, this.fd)),
                this.hoverRect.resize(this.valueConverter.convertPointsToPixels(width, this.fd))
            ]);
        }
    };

    moveAreaRectangle = async (x, width) => {
        await Promise.all([
            this.areaRect.move(this.valueConverter.convertPointsToPixels(x, this.fd)),
            this.areaRect.resize(this.valueConverter.convertPointsToPixels(width, this.fd))
        ]);
    };

    moveSelectRectangle = async (x, width) => {
        await Promise.all([
            this.selectRect.move(this.valueConverter.convertPointsToPixels(x, this.fd)),
            this.selectRect.resize(this.valueConverter.convertPointsToPixels(width, this.fd))
        ]);
    };
}
